export const isAnswerCorrect = (userAnswer, correctAnswers, ignoreCases, category) => {
  const correctArr = Array.isArray(correctAnswers) ? correctAnswers : [correctAnswers];
  
  const isMath = category === 'Mathematics' || 
                 /[\$\\\^\_]/.test(String(userAnswer)) || 
                 correctArr.some(a => /[\$\\\^\_]/.test(String(a)));
  
  const normalize = (str, lowercase) => {
    if (typeof str !== 'string' && typeof str !== 'number') return '';
    let stripped = String(str);
    
    // Always strip ALL dollar signs to handle mixed formatting
    stripped = stripped.replace(/\$/g, '');
    
    if (isMath) {
      stripped = stripped.replace(/\\displaystyle/g, '');
      stripped = stripped.replace(/\s+/g, '');

      // Normalize \frac{A}{B} into A/B, e.g. \frac{21}{8} vs 21/8 — this has
      // to run before the generic brace-stripping loop below, since that
      // loop only unwraps single-character groups and would otherwise mangle
      // a multi-digit numerator/denominator into an unmatched half-stripped
      // state (e.g. \frac{21}{8} -> \frac{21}8) that nothing else catches.
      stripped = stripped.replace(/\\frac\{([^{}]+)\}\{([^{}]+)\}/g, '$1/$2');

      // Normalize LaTeX brace omissions (e.g. \frac12 vs \frac{1}{2}, \sqrt2 vs \sqrt{2})
      // Repeatedly remove braces around single characters or single commands
      let prev;
      do {
        prev = stripped;
        stripped = stripped.replace(/\{([a-zA-Z0-9]|\\[a-zA-Z]+)\}/g, '$1');
      } while (stripped !== prev);

      // Normalize optional parentheses after common function names when the
      // argument is a single variable/number, e.g. \ln(x) vs \ln x
      stripped = stripped.replace(/\\(ln|log|sin|cos|tan|cot|sec|csc|exp)\(([a-zA-Z0-9]+)\)/g, '\\$1$2');

      // Catches the case where \frac was already written without braces at
      // all, e.g. \frac12 vs 1/2
      stripped = stripped.replace(/\\frac([a-zA-Z0-9])([a-zA-Z0-9])/g, '$1/$2');

    } else {
      stripped = stripped.trim();
    }
    return lowercase ? stripped.toLowerCase() : stripped;
  };

  // A comma-separated list of terms (e.g. the two roots of an equation) is
  // an unordered set, unless it's a single parenthesized tuple like a
  // coordinate pair, where the order is actually meaningful.
  const asSortedSet = (str) => {
    if (!str.includes(',')) return null;
    if (/^(\(|\[|\\left[(\[])/.test(str)) return null;
    const parts = str.split(',').map(p => p.trim()).filter(p => p.length > 0);
    if (parts.length < 2) return null;
    return parts.slice().sort().join(',');
  };

  const lower = ignoreCases === 'true' || ignoreCases === true;
  const normalizedUser = normalize(userAnswer, lower);

  return correctArr.some(ans => {
    const normalizedAns = normalize(ans, lower);
    if (normalizedAns === normalizedUser) return true;

    if (isMath) {
      const userSet = asSortedSet(normalizedUser);
      const ansSet = asSortedSet(normalizedAns);
      if (userSet !== null && ansSet !== null && userSet === ansSet) return true;
    }
    return false;
  });
};
